export function initSignupBackButton(): void {
  const button = document.getElementById('signUpBackButton');
  button?.addEventListener('click', () => history.back());
}
